import { Injectable } from '@angular/core';
import { Geolocation, Coordinates, } from '@ionic-native/geolocation/ngx';
import { NativeGeocoder } from '@ionic-native/native-geocoder/ngx';
import { Platform } from '@ionic/angular';
import { Observable } from 'rxjs';
/*
 Generated class for the GeolocationService provider.

 See https://angular.io/docs/ts/latest/guide/dependency-injection.html
 for more info on providers and Angular 2 DI.
 */
@Injectable()
export class GeolocationService {
    private lastLocation: Coordinates;

    constructor(platform: Platform, private geolocation: Geolocation) {
        platform.ready().then(() => {
          console.debug("geo location [00]", this.geolocation)
          if(this.geolocation) {
            this.geolocation.getCurrentPosition().then(pos => {
              console.debug("geo location [0]", pos)
              this.lastLocation = pos.coords;
          }, err => {


          });

          this.geolocation.watchPosition().pipe().subscribe((pos: any) => {
            console.debug("geo location [1]", pos)
              this.lastLocation = pos.coords;
          }, err => {

           });
          }
          if(1) {
            this.getCurrentPosition()
            .subscribe((location)=>{
              console.debug("geo location [2]", location)
              this.lastLocation = location.coords;
            })
          }
        });
    }
    public getLatitude(): number {
        if (this.lastLocation) return this.lastLocation.latitude;
        else return null;
    }

    public getLongitude(): number {
        if (this.lastLocation) return this.lastLocation.longitude;
        else return null;
    }

    getCurrentPosition(): Observable<GeolocationPosition> {
      return new Observable(observer => {
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              observer.next(position);
              observer.complete();
            },
            (error) => observer.error(error)
          );
        } else {
          observer.error('Geolocation is not available in this browser.');
        }
      });
    }


    /**
     * Stop the geolocation watch
     */
    public stop() {
        // if(isPresent(this.watch) && !this.watch.isUnsubscribed)
        //     this.watch.unsubscribe();
    }

}

